/**
 * Determines the best color between white and black to contract against
 * a provided color.
 * @param {string} hexColor - must be a hex value in the format '#000000'.
 * @returns {string} - returns either white or black hex value.
 */
export const getContrastColor = (hexColor) => {
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);

  // Calculate the relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
};

/**
 * Returns a faded (semi-transparent) version of the provided hex color.
 *
 * @param {string} hexColor - The hex color to fade. Must be in the format '#RRGGBB'.
 * @param {number} alpha - The alpha (opacity) value from 0 to 1.
 * @returns {string} An rgba color string with the specified transparency.
 */
export function getFadeColor(hexColor, alpha = 0.5) {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Determines if the incoming string is a proper hex value in the format '#000000'
 * @param {string} value - The string to test against
 * @returns {boolean}
 */
export const isHexColor = (value) => {
  const regex = /^#[0-9A-F]{6}$/i;
  return regex.test(value);
};
